// API service for backend endpoints
const API_BASE_URL = '/api';

// Helper function to get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Helper function to make API requests
const apiRequest = async (endpoint, options = {}) => {
  const token = getAuthToken();
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
    ...options,
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`API request failed for ${endpoint}:`, error);
    throw error;
  }
};

// Auth API
export const authAPI = {
  login: async (email, password) => {
    return apiRequest('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  },
};

// Families API
export const familiesAPI = {
  list: async () => {
    return apiRequest('/families');
  },
  
  create: async (familyData) => {
    return apiRequest('/families', {
      method: 'POST',
      body: JSON.stringify(familyData),
    });
  },
  
  update: async (familyId, updateData) => {
    return apiRequest(`/families/${familyId}`, {
      method: 'PUT',
      body: JSON.stringify(updateData),
    });
  },
  
  delete: async (familyId) => {
    return apiRequest(`/families/${familyId}`, {
      method: 'DELETE',
    });
  },
};

// Donations API
export const donationsAPI = {
  getAll: async () => {
    return apiRequest('/donations');
  },
  
  getRecent: async () => {
    return apiRequest('/donations/recent');
  },
  
  addManual: async (donationData) => {
    return apiRequest('/donations', {
      method: 'POST',
      body: JSON.stringify(donationData),
    });
  },
  
  linkToFamily: async (donationId, familyId) => {
    return apiRequest(`/donations/${donationId}/link`, {
      method: 'POST',
      body: JSON.stringify({ familyId }),
    });
  },
};

// Stripe API
export const stripeAPI = {
  createCheckoutSession: async (sessionData) => {
    return apiRequest('/stripe/create-checkout-session', {
      method: 'POST',
      body: JSON.stringify(sessionData),
    });
  },
};

// Users API
export const usersAPI = {
  list: async () => {
    return apiRequest('/users');
  },
  
  create: async (email, password) => {
    return apiRequest('/users', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  },
  
  updatePassword: async (userId, password) => {
    return apiRequest(`/users/${userId}/password`, {
      method: 'PUT',
      body: JSON.stringify({ password }),
    });
  },
  
  delete: async (userId) => {
    return apiRequest(`/users/${userId}`, {
      method: 'DELETE',
    });
  },
};

// Health check
export const healthAPI = {
  check: async () => {
    return apiRequest('/health');
  },
};

